// extracted by mini-css-extract-plugin
module.exports = {"root":"PlasmicTableTh_root__ur5aW","slotTargetChildren":"PlasmicTableTh_slotTargetChildren__Cgaf_"};